import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import '@nile/components/src/Components/UI/StarRating/StarRating.scss';

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  maxStars?: number;
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  maxStars = 5,
  size = 'lg',
  color = 'white',
  className = ''
}) => {
  return (
    <div className={`star-rating-container ${className}`}>
      {Array.from({ length: maxStars }, (_, index) => index + 1).map((star) => (
        <span
          key={star}
          className="star-icon pointer"
          onClick={() => onRatingChange(star)}
        >
          <SVGIcon
            name={star <= rating ? 'StarFavoriteFill' : 'StarFavorite'}
            size={size}
            color={color}
          />
        </span>
      ))}
    </div>
  );
};

export default StarRating;
